import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEnvironmentService } from '../api-environment.service';

@Injectable()
export class TemplateService {

  constructor(
    private httpClient: HttpClient,
    private apiService: ApiEnvironmentService
  ) {}

  getHeaderHtml(): Observable<string> {
    return this.httpClient.get(this.apiService.getApiBaseHref().replace('HDWLocatorApi','') + "/api/template/header", {
        responseType: 'text'
    });
  }

  getFooterHtml(): Observable<string> {
    return this.httpClient.get(this.apiService.getApiBaseHref().replace('HDWLocatorApi','') + "/api/template/footer", {
        responseType: 'text'
    });
  }

}
